import actions from '@/core/store/penalidades/itens/actions'

export default {
	actions,
}
